(function(angular) {
    'use strict';

    angular.module('um.filters').controller('filters.overview.controller', filtersOverviewCtrl);

    filtersOverviewCtrl.$inject = ['filtersService', '$modal', 'trackingService', 'rolesService', '$q'];

    function filtersOverviewCtrl(filtersService, $modal, trackingService, rolesService, $q) {
        var that = this;

        this.$onInit = function() {
            const promises = [
                filtersService.getAllFilters(),
                rolesService.getServiceAccounts()
            ];

            return $q.all(promises).then(function(values) {
                that.filters = _.nth(values, 0) || [];
                const serviceAccounts = _.nth(values, 1) || [];

                that.filters.forEach((filter) => {
                    filter.account = filtersService.getAccountNameById(filter.accountId, serviceAccounts);
                });
            });
        };

        that.predicate = 'name';
        that.reverse = false;

        that.tableHeaders = [
            {
                active: true,
                sortable: true,
                searchable: true,
                predicate: 'name',
                i18n: 'FILTERS_NAME',
                reverse: false,
                width: 4
            },
            {
                active: true,
                sortable: true,
                searchable: true,
                predicate: 'account',
                i18n: 'FILTERS_ACCOUNT',
                reverse: false,
                width: 6
            },
            {
                active: true,
                sortable: true,
                searchable: false,
                predicate: 'number_users',
                i18n: 'FILTERS_NUMBER_USERS',
                reverse: false,
                width: 1
            },
            {
                active: false,
                sortable: false,
                searchable: false,
                i18n: 'ACTIONS',
                reverse: false,
                width: 1
            }
        ];

        that.selectedSearchKey = '$';
        that.elementList = _.filter([{
            active: true,
            searchable: true,
            predicate: '$',
            i18n: 'FILTER_ANY'
        }].concat(that.tableHeaders), function(el) {
            return el.searchable;
        });

        that.search = {
            $: ''
        };

        that.elementMapping = {
            key: 'predicate',
            title: 'i18n',
            active: 'active'
        };

        that.clickHandlers = {
            leftClick: function(index, element) {
                var searchText;
                if (element && element.predicate) {
                    searchText = that.search[that.selectedSearchKey];
                    that.selectedSearchKey = element.predicate;
                    that.search = {};
                    that.search[that.selectedSearchKey] = searchText;
                }
            }
        };

        that.sortHeader = function sortHeader(tableHeader) {
            if (tableHeader.predicate) {
                tableHeader.reverse = !tableHeader.reverse;
                that.predicate = tableHeader.predicate;
                that.reverse = tableHeader.reverse;
            }
        };

        that.deleteFilter = function deleteFilter(filter) {
            trackingService.action('filter.delete');

            that.modalInstance = $modal.open({
                templateUrl: 'template/modal/assureConfirmDelete.html',
                controller: 'filters.delete.controller',
                resolve: {
                    filter: function() {
                        return _.cloneDeep(filter);
                    }
                }
            });
        };

        /**
         * Checks the highlighting should be done on search or not
         * That is the case if either 'Any' or the matching predicate is selected
         *
         * @param {String} predicate
         * @returns {*} Value key in search object or false value
         */
        that.checkHighlighting = function checkHighlighting(predicate) {
            if (that.selectedSearchKey === predicate || that.selectedSearchKey === that.elementList[0].predicate) {
                return that.search[that.selectedSearchKey];
            }
            return '';
        };
    }
})(window.angular);
